module.exports = __webpack_public_path__ + "img/md5-hover2.040d5ade.png";